import React from 'react';
import PropTypes from 'prop-types';

export default function WidgetErrorMessage({ children }) {
    return <div className="widget__error-message">{children}</div>;
}

WidgetErrorMessage.propTypes = {
    children: PropTypes.node.isRequired
};
